import './styles.css'
import React from 'react'
import { Message } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'
import createAction from '../../../../../../redux/actions/createAction'
import { HIDE_BOOKINGS_MODAL_ERROR_MESSAGE } from '../../../../../../redux/actions/actionTypes'

function BookingsModalErrorBanner(props) {
  const { isShowing, header, content } = props
  const dispatch = useDispatch()

  return (
    <div
      className={`${isShowing ? 'kegCollectionModalErrorBanner' : 'kegCollectionModalErrorHidden'}`}
    >
      <Message
        negative
        content={content}
        header={header}
        onDismiss={() => dispatch(createAction(HIDE_BOOKINGS_MODAL_ERROR_MESSAGE))}
        icon="exclamation triangle"
      />
    </div>
  )
}

export default React.memo(BookingsModalErrorBanner)
